import { AbstractControl,  ValidatorFn  } from '@angular/forms';

export function telefoneValidator(control: AbstractControl): { [key: string]: boolean } | null { 
    if(control.value === "")
    {
      return null;
    }
    if(control.value.length != 10){
        return({'telefone': true});
    }
    return null;
};